import React, { FC, useEffect, useState } from "react"

import { yupResolver } from "@hookform/resolvers/yup"
import { useMutationResetPassword } from "api/reactQuery/mutations/password"
import { AxiosError } from "axios"
import { useCustomSnackbar } from "hooks/snackbar"
import { FormProvider, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { getErrorMessageWithFallback } from "../../../utils/api/api"
import { changePasswordSchema } from "../../../utils/yup"
import Layout from "../layout"
import First from "./pages/first"
import Second from "./pages/second"

interface IChangePasswordForm {
  password: string
  confirmPassword: string
}

const ChangePassword: FC = () => {
  const { showSnackbar } = useCustomSnackbar()
  const { t } = useTranslation()

  const [linkToResetPassword, setLinkToResetPassword] = useState(false)
  const [page, setPage] = useState(0)
  const [token, setToken] = useState("")

  const methods = useForm<IChangePasswordForm>({
    resolver: yupResolver(changePasswordSchema),
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  })

  useEffect(() => {
    setToken(window.location.search.slice(7))
  }, [])

  const { mutate, isLoading } = useMutationResetPassword({
    options: {
      onSuccess: () => {
        setPage(1)
      },
      onError: (error: AxiosError) => {
        const errorMessage = t(
          getErrorMessageWithFallback(
            error,
            "noAuthFlow.yourTokenWasExpiredOrIsInvalidPleaseResetPasswordOnceAgain"
          )
        )

        showSnackbar({
          title: errorMessage,
          variant: "error",
        })
        
        if (error.response?.status === 401 || error.response?.status === 400) {
          setLinkToResetPassword(true)
        }
      },
    },
  })

  const onSubmit = (data: IChangePasswordForm) => {
    mutate({
      password: data.password,
      password2: data.confirmPassword,
      token: token,
    })
  }

  return (
    <Layout>
      {page === 0 && (
        <FormProvider {...methods}>
          <First
            onSubmit={methods.handleSubmit(onSubmit)}
            linkToResetPassword={linkToResetPassword}
            isLoading={isLoading}
          />
        </FormProvider>
      )}
      {page === 1 && <Second />}
    </Layout>
  )
}

export default ChangePassword
